import api from './api';

/**
 * Unified dashboard counts payload returned by GET /api/v1/dashboard/counts.
 * Collapses five separate polling endpoints (email, task, transaction,
 * notification counts) into a single request to reduce backend pressure.
 */
export interface DashboardCounts {
  emails: { total_inbox: number; total_unread: number };
  tasks: { active: number; total_unfinished: number; overdue: number };
  transactions: { pending: number };
  notifications: { unread: number };
}

export interface DashboardCountsParams {
  emailAccountId?: string | null;
  accountScope?: 'unified' | 'unassigned' | null;
}

export const getDashboardCounts = async (
  params: DashboardCountsParams = {}
): Promise<DashboardCounts> => {
  const search = new URLSearchParams();
  if (params.emailAccountId) {
    search.append('email_account_id', params.emailAccountId);
  }
  if (params.accountScope) {
    search.append('account_scope', params.accountScope);
  }
  const qs = search.toString();
  const url = qs ? `/api/v1/dashboard/counts?${qs}` : '/api/v1/dashboard/counts';
  const response = await api.get<DashboardCounts>(url);
  return response.data;
};
